// extracted by mini-css-extract-plugin
export var accordionBody = "style-mod--accordion-body--52a5b";
export var accordionIcon = "style-mod--accordion-icon--919ae";
export var accordionIconOpen = "style-mod--accordion-icon-open--da984";
export var accordionTitle = "style-mod--accordion-title--e625b";
export var hayaImage = "style-mod--haya-image--71c25";
export var opCBody = "style-mod--op-c-body--61c12";
export var opCard = "style-mod--op-card--7ad0a";
export var opCardBody = "style-mod--op-card-body--e366d";
export var opContent = "style-mod--op-content--4a243";
export var opLink = "style-mod--op-link--e0b11";
export var opList = "style-mod--op-list--2e261";
export var opTitle = "style-mod--op-title--7614b";
export var pdpOurPromise = "style-mod--pdp-our-promise--8c999";
export var prodHighlights = "style-mod--prod-highlights--c3c6d";
export var toggleHeader = "style-mod--toggle-header--ea0ae";